import Translate from 'translate.js';
// tslint:disable:no-any
const defaultLanguage = 'es';
const detectedLanguage = ((navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage).toLowerCase();
export const lang = detectedLanguage.substr(0, 2);
export const langAndRegion = detectedLanguage;
const languages = {
    es: {
        typePassenger: {
            adult: 'adulto',
            child: 'pequeño',
            handicapped: 'discapacitado',
            infant: 'bebe',
            military: 'militar',
            senior: 'mayor',
            student: 'estudiante',
        },
        download: 'descargar',
        add: 'añadir',
        address: 'dirección',
        additionalInformation: 'información adicional',
        administrator: 'administrador',
        adult: 'adulto',
        affiliate: 'afiliado',
        available: 'disponible',
        cancel: 'cancelar',
        canceled: 'cancelado',
        capacity: 'capacidad',
        child: 'pequeño',
        discountReasons: 'razon descuento',
        handicapped: 'discapacitado',
        infant: 'bebe',
        military: 'militar',
        senior: 'mayor',
        student: 'estudiante',
        afiliate: 'afiliado',
        afiliateOptional: 'afiliado (opcional)',
        all: 'todos',
        appName: 'Tpv web',
        article: 'artículo',
        articles: 'artículos',
        barcode: 'código de barras',
        boardingPass: 'tarjeta embarque',
        branch: 'delegación',
        brand: 'marca',
        branches: 'delegaciones',
        businessName: 'nombre fiscal',
        businessunit: 'negocio',
        businessUnit: 'negocio',
        businessunits: 'negocios',
        businessUnits: 'negocios',
        cajaOpen: 'caja abierta',
        cash: 'efectivo',
        card: 'tarjeta',
        cashDeskOpen: 'la caja ya está abierta',
        checkins: 'checkins',
        city: 'ciudad',
        client: 'cliente',
        code: 'código',
        codeDiscount: 'código descuento',
        collaboratorStretches: 'servicios en colaboración',
        collaboratorsType: 'colaboración',
        collaboratorPacketsType: 'paquetes colaboración',
        confirmDelete: '¿Confirmar eliminar?',
        confirmDisable: '¿Confirmar deshabilitar?',
        confirmEnable: '¿Confirmar habilitar?',
        contactName: 'persona de contacto',
        contactPhone: 'teléfono de contacto',
        cost: 'coste',
        credit: 'crédito',
        customers: 'clientes',
        dataClient: 'datos cliente',
        date: 'fecha',
        dateBook: 'fecha de uso',
        datecheck: 'emitido',
        dateClose: 'fecha cierre',
        daterefund: 'cancelado',
        datevalited: 'validado',
        dateOpen: 'fecha apertura',
        day: 'hoy',
        defer: 'pendiente',
        delete: 'eliminar',
        description: 'descripción',
        desde: 'desde',
        destination: 'destino',
        device: 'dispositivo',
        devices: 'dispositivos',
        disable: 'deshabilitar',
        disabled: 'deshabilitados',
        disabledDate: 'no hay horas para el día seleccionado',
        disabled_at: 'deshabilitado en',
        discountReason: 'razón descuento',
        discountReasonOptional: 'razón descuento (opcional)',
        due: 'pendiente',
        email: 'email',
        enable: 'habilitar',
        extras: 'extras',
        families: 'familias',
        family: 'familia',
        fix: 'fijo',
        footer: 'pie',
        hasta: 'hasta',
        header: 'cabecera',
        help: 'ayuda',
        hoponHopoff: 'HopON-HopOFF',
        id: 'ID',
        image: 'imagen',
        imageProperties: 'imagen en formato jpg con un mínimo de 600x600 px',
        invoice: 'factura',
        lastname: 'apellidos',
        license: 'licencia',
        licenses: 'licencias',
        logIn: 'iniciar sesión',
        logOut: 'salir',
        manufacturer: 'fabricante',
        margin: 'margen',
        maximumCapacityReached: 'máxima capacidad alcanzada',
        model: 'modelo',
        minToReserve: 'mínimo para reservar',
        modelo: 'modelo',
        mostrar: 'mostrar',
        month: 'mes',
        mr_mrs: 'Sr/Sra',
        name: 'nombre',
        noDatos: 'no hay datos que nostrar',
        noHourSelected: 'no hay hora seleccionada',
        none: 'ninguna',
        nothingModified: 'no se han realizado cambios',
        number: 'numero',
        numero: 'número de ticket',
        ok: 'aceptar',
        operario: 'operario',
        operationlines: 'líneas',
        operationline: 'línea',
        operationLine: 'línea',
        origin: 'origen',
        orphan: 'sin familia',
        other: 'otro',
        packet: 'paquete',
        packets: 'paquetes',
        parael: 'para el',
        parent: 'padre',
        paraUsarEntre: 'para usar entre',
        paraUsarHasta: 'para usar hasta',
        yEl: 'y el',
        passengercategories: 'categorias de pasajero',
        password: 'contraseña',
        payDue: 'completar pago',
        payments: 'pagos',
        pending: 'pendiente',
        percentage: 'porcentaje',
        phone: 'teléfono',
        policy: 'política',
        price: 'precio',
        pricesWithoutTax: 'precios (sin IVA)',
        printPrice: 'imprimir precio',
        propierties: 'propiedades',
        province: 'provincia',
        quantity: 'cantidad',
        receiptLayout: 'Pantilla de recibo',
        recovery: 'olvidé la contraseña',
        reference: 'referencia',
        refund: 'anular venta',
        refundAsk: '¿anular venta?',
        refunded: 'anulado',
        reports: 'informes',
        reserved: 'reservado',
        reset: 'reiniciar',
        resident: 'residente',
        role: 'rol',
        routes: 'rutas',
        saleDate: 'desde',
        sales: 'ventas',
        save: 'guardar',
        search: 'buscar',
        select: 'seleccione',
        selectOne: 'seleccione uno',
        selectOneOptional: 'seleccione uno (opcional)',
        sellBy: 'vendido por',
        seller: 'vendedor',
        send: 'enviar',
        serial: 'numero de serie',
        services: 'servicios',
        settings: 'configuración',
        sinValidar: 'sin validar',
        stock: 'stock',
        stockable: 'almacenable',
        stretch: 'tramo',
        stretches: 'tramos',
        supervisor: 'supervisor',
        surname: 'apellidos',
        tax: 'impuesto',
        taxes: 'impuestos',
        telephone: 'teléfono',
        terminal: 'terminal de venta',
        terminalnumero: 'número',
        ticket: 'ticket',
        tickets: 'tickets',
        ticketsRefunded: 'tickets cancelados',
        tipoPago: 'método de pago',
        type: 'tipo',
        typePassengers: 'tipo de pasajero',
        timeCancel: 'Tiempo máximo para cancelar ticket (en minutos)',
        timeExpiration: 'Tiempo caducidad de ticket (en días) 0 para el resto del día actual',
        tin: 'NIF-CIF',
        totalDiscount: 'total descuento',
        totalRefund: 'total abonado',
        tradename: 'nombre comercial',
        transfer: 'transferencia',
        username: 'usuario',
        user: 'usuario',
        users: 'usuarios',
        valitedNow: 'validar ahora',
        validoPara: 'válido para',
        vuelta: 'ida-vuelta',
        week: 'semana',
        wharehouse: 'mi catálogo',
        year: 'año',
        zip: 'código postal',
        netAmount: 'base imponible',
        discount: 'descuento',
        taxBase: 'base impuestos',
        taxAmount: 'impuestos',
        total: 'total',
        from: 'desde',
        to: 'hasta',
        cashDesk: 'caja',
        state: 'estado',
        cashAmount: 'efectivo',
        cardAmount: 'tarjeta',
        open: 'apertura',
        close: 'cerrar',
        closeCashdesk: 'cerrar caja',
        closeSession: 'cerrar sesión',
        closeSessionAsk: 'cerrar sesión?',
        partialClose: 'cierre parcial',
        error: {
            unableConnect: 'imposible conectar, comprobar conexión',
            tryAgainLater: 'intentar de nuevo más tarde',
            loginAgain: 'iniciar sesión de nuevo',
            userNoAccess: 'acceso prohibido para este tipo de usuario',
        },
    },
    en: {
        add: 'add',
        address: 'address',
        administrator: 'administrator',
        all: 'all',
        appName: 'Tpv web',
        article: 'article',
        articles: 'articles',
        barcode: 'barcode',
        branch: 'branch',
        branches: 'branches',
        businessName: 'business name',
        cancel: 'cancel',
        cashDeskOpen: 'cash desk already opened',
        city: 'city',
        client: 'client',
        code: 'code',
        confirmDelete: 'Confirm delete?',
        confirmDisable: 'Confirm disable?',
        confirmEnable: 'Confirm enable?',
        contactName: 'contact name',
        contactPhone: 'contact phone',
        cost: 'cost',
        customers: 'customers',
        date: 'date',
        delete: 'delete',
        description: 'description',
        disable: 'disable',
        disabled: 'disabled',
        email: 'email',
        enable: 'enable',
        families: 'families',
        family: 'family',
        footer: 'footer',
        header: 'header',
        id: 'ID',
        image: 'image',
        imageProperties: 'image in jpg format and with a minimun of 600x600 px',
        invoice: 'invoice',
        lastname: 'lastname',
        logIn: 'log in',
        logOut: 'log out',
        margin: 'margin',
        name: 'name',
        none: 'none',
        nothingModified: 'nothing modified',
        ok: 'ok',
        orphan: 'without family',
        parent: 'parent',
        password: 'password',
        phone: 'phone',
        policy: 'policy',
        price: 'price',
        propierties: 'propierties',
        province: 'province',
        quantity: 'quantity',
        recovery: 'I forgot my password',
        reference: 'reference',
        refund: 'refund sale',
        refundAsk: '¿refund sale?',
        reports: 'reports',
        reset: 'reset',
        role: 'role',
        saleDate: 'since',
        sales: 'sales',
        save: 'save',
        search: 'search',
        seller: 'seller',
        send: 'send',
        settings: 'settings',
        stock: 'stock',
        stockable: 'stockable',
        supervisor: 'supervisor',
        tax: 'tax',
        tin: 'TIN',
        tradename: 'tradename',
        username: 'username',
        users: 'users',
        wharehouse: 'wharehouse',
        zip: 'postal code',
        number: 'number',
        netAmount: 'net amount',
        discount: 'discount',
        taxBase: 'tax base',
        taxAmount: 'tax amount',
        total: 'total',
        from: 'from',
        to: 'to',
        cashDesk: 'cash desk',
        state: 'state',
        cashAmount: 'cash amount',
        cardAmount: 'card amount',
        open: 'open',
        close: 'close',
        closeSession: 'sign off',
        closeSessionAsk: 'sign off?',
        partialClose: 'partialClose',
        error: {
            unableConnect: 'unable to connect, check network',
            tryAgainLater: 'try again later',
            loginAgain: 'log in again',
            noSellers: 'prohibited access for this type of user',
        },
    },
};
const translate = Translate(languages[lang] || defaultLanguage, {
    debug: process.env.NODE_ENV === 'development',
    namespaceSplitter: ':',
});
export const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);
export const capitalizeAll = (text) => text.toUpperCase();
export const t = (key, replacements) => translate(key, replacements);
export const T = (key, replacements) => capitalize(t(key, replacements));
export const TT = (key, replacements) => capitalizeAll(t(key, replacements));



//////////////////
// WEBPACK FOOTER
// ./src/helpers/i18n.ts
// module id = 8
// module chunks = 0